import { render, staticRenderFns } from "./FPLensMetricsIcon.vue?vue&type=template&id=383ce4e5&scoped=true"
import script from "./FPLensMetricsIcon.vue?vue&type=script&lang=js"
export * from "./FPLensMetricsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383ce4e5",
  null
  
)

export default component.exports